export const zh = {
  // Nav
  'nav.home': '主頁',
  'nav.practice': '練習',
  'nav.history': '歷史記錄',
  'nav.bookmarks': '收藏題目',
  'nav.wrongQuestions': '錯題集',
  'nav.admin': '管理',
  'nav.logout': '登出',
  'nav.login': '登入',
  'nav.register': '註冊',

  // Auth
  'auth.email': '電郵地址',
  'auth.password': '密碼',
  'auth.displayName': '顯示名稱',
  'auth.login': '登入',
  'auth.register': '建立帳戶',
  'auth.loginPrompt': '已有帳戶？',
  'auth.registerPrompt': '沒有帳戶？',
  'auth.loginLink': '立即登入',
  'auth.registerLink': '建立帳戶',

  // Dashboard
  'dash.welcome': '歡迎回來',
  'dash.totalAttempts': '總練習次數',
  'dash.completed': '已完成',
  'dash.avgScore': '平均分數',
  'dash.mastery': '掌握程度概覽',
  'dash.mastered': '已掌握',
  'dash.review': '複習中',
  'dash.learning': '學習中',
  'dash.unseen': '未做過',
  'dash.recentAttempts': '最近練習',
  'dash.weakAreas': '薄弱環節',
  'dash.progress': '各卷進度',
  'dash.startPractice': '開始練習',

  // Catalog
  'catalog.title': '練習題目',
  'catalog.selectPaper': '選擇試卷',
  'catalog.selectTopic': '選擇主題',
  'catalog.selectChapter': '選擇章節',
  'catalog.questionsAvailable': '道題目可用',
  'catalog.startQuiz': '開始測驗',
  'catalog.questionCount': '題目數量',
  'catalog.mode': '模式',
  'catalog.paper': '整卷練習',
  'catalog.topic': '按主題',
  'catalog.chapter': '按章節',
  'catalog.mock': '模擬考試 (40題)',
  'catalog.random': '隨機練習',

  // Quiz
  'quiz.question': '題目',
  'quiz.of': '/',
  'quiz.submit': '提交測驗',
  'quiz.next': '下一題',
  'quiz.prev': '上一題',
  'quiz.finish': '完成並查看',
  'quiz.bookmark': '收藏',
  'quiz.unbookmark': '取消收藏',
  'quiz.timeElapsed': '用時',
  'quiz.answered': '已答',
  'quiz.confirmSubmit': '確定提交嗎？你有 {count} 道題未作答。',
  'quiz.confirmAbandon': '確定放棄此測驗嗎？',
  'quiz.abandon': '放棄',

  // Results
  'result.title': '測驗結果',
  'result.score': '分數',
  'result.correct': '正確',
  'result.incorrect': '錯誤',
  'result.unanswered': '未作答',
  'result.time': '用時',
  'result.review': '查看答案',
  'result.retake': '重新測驗',
  'result.backToDash': '返回主頁',
  'result.explanation': '解釋',
  'result.yourAnswer': '你的答案',
  'result.correctAnswer': '正確答案',

  // History
  'history.title': '練習歷史',
  'history.noAttempts': '尚未進行任何練習',
  'history.mode': '模式',
  'history.score': '分數',
  'history.questions': '題數',
  'history.date': '日期',
  'history.duration': '用時',
  'history.status': '狀態',
  'history.view': '查看',

  // Bookmarks
  'bookmarks.title': '收藏題目',
  'bookmarks.empty': '暫無收藏題目',
  'bookmarks.remove': '移除',

  // Wrong Questions
  'wrong.title': '錯題複習',
  'wrong.empty': '沒有錯題 - 做得好！',
  'wrong.reviewAll': '複習所有錯題',
  'wrong.filter': '按試卷篩選',
  'wrong.attempts': '嘗試次數',
  'wrong.correctRate': '正確率',

  // Admin
  'admin.dashboard': '管理控制台',
  'admin.questions': '題目管理',
  'admin.users': '用戶管理',
  'admin.import': '匯入 / 匯出',
  'admin.stats': '統計數據',
  'admin.totalUsers': '總用戶數',
  'admin.totalQuestions': '總題目數',
  'admin.totalAttempts': '總練習次數',
  'admin.avgScore': '平台平均分',
  'admin.search': '搜索...',
  'admin.create': '新增',
  'admin.edit': '編輯',
  'admin.save': '儲存',
  'admin.cancel': '取消',
  'admin.delete': '刪除',
  'admin.status': '狀態',
  'admin.role': '角色',
  'admin.actions': '操作',

  // Common
  'common.loading': '載入中...',
  'common.error': '發生錯誤',
  'common.retry': '重試',
  'common.noData': '暫無數據',
  'common.page': '頁',
  'common.previous': '上一頁',
  'common.next': '下一頁',
  'common.all': '全部',
  'common.language': '語言',
  'common.english': 'English',
  'common.chinese': '中文',
  'common.bilingual': '雙語',
}
